import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebartemplateComponent } from './sidebartemplate.component';



@NgModule({
    imports: [
        CommonModule,
        SidebartemplateComponent
    ],
    exports: [SidebartemplateComponent]
})
export class SidebartemplateModule { }
